<script>
import ModuleTitle from '../common/ModuleTitle.vue'
import CheckMore from '../common/CheckMore.vue'

import { getPageThemeColor, getLinearColor } from '@/utils/modules/getStyles'

export default {
  name: 'Comp6',
  components: { ModuleTitle, CheckMore },
  props: {
    moduleOption: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      path: this.$route.path
    }
  },
  methods: { getPageThemeColor, getLinearColor }
}
</script>

<template>
  <div class="modules-id-6">
    <module-title :title="moduleOption.title" margin-bottom="30" />
    <div class="comp-transverse-3 modules-id-6-content">
      <div v-for="(v, i) in moduleOption.list.slice(0, 4)" :key="`modules-6-${v.id}`" class="item">
        <p class="item-order" :style="{background: `linear-gradient(95deg, ${getLinearColor(path)[0]}, ${getLinearColor(path)[1]})`}">
          {{ i + 1 }}
        </p>
        <div class="title-box">
          <p
            class="item-title"
            :style="{backgroundImage: `linear-gradient(#fff, #fff), linear-gradient(90deg, ${getLinearColor(path)[0]}, ${getLinearColor(path)[1]})`}"
          >
            {{ v.headline | textLenHandler(20) }}
          </p>
        </div>
      </div>
      <check-more />
    </div>
  </div>
</template>

  <style lang="scss" scoped>
  .modules-id-6-content {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    row-gap: 30px;
    .item {
      width: 455px;
      height: 40px;
      border-radius: 5px;
      box-sizing: border-box;
      display: flex;
      column-gap: 5px;
      align-items: center;
      .item-order {
        width: 40px;
        height: 40px;
        text-align: center;
        line-height: 40px;
        // background: linear-gradient(95deg, #46A25E, #60B642);
        border-radius: 5px;

        font-size: 24px;
        font-family: siyuansong;
        font-weight: 800;
        color: #fff;
      }
      .title-box {
        display: grid;
        place-items: center;
      }
      .item-title {
        width: 410px;
        height: 40px;
        line-height: 40px;
        background-color: #fff;
        border: 2px solid transparent;
        border-radius: 5px;
        // background-image: linear-gradient(#fff, #fff), linear-gradient(90deg, #46A25E, #60B642);
        background-origin: border-box;
        background-clip: content-box, border-box;
        text-indent: 15px;

        font-size: 17px;
        font-weight: bold;
        color: #000;
      }
    }
  }
  </style>
